var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5C5.37253 0.5 0 5.87253 0 12.5C0 19.1274 5.37253 24.5 12 24.5C18.6274 24.5 24 19.1274 24 12.5C24 5.87253 18.6273 0.5 12 0.5ZM8.79836 18.3014H6.16364V9.7894H8.79836V18.3014ZM7.46845 8.67468C6.60798 8.67468 5.91041 7.97143 5.91041 7.10407C5.91041 6.23661 6.60807 5.53341 7.46845 5.53341C8.32882 5.53341 9.02638 6.23661 9.02638 7.10407C9.02643 7.97148 8.32887 8.67468 7.46845 8.67468ZM18.672 18.3014H16.05V13.8333C16.05 12.6078 15.5845 11.9238 14.6155 11.9238C13.5609 11.9238 13.01 12.6362 13.01 13.8333V18.3014H10.483V9.7894H13.01V10.9358C13.01 10.9358 13.7701 9.52976 15.575 9.52976C17.3799 9.52976 18.672 10.6318 18.672 12.9117L18.672 18.3014Z",
    fill: "url(#paint0_linear_5776_114919)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5776_114919",
    x1: 3.51471,
    y1: 4.01471,
    x2: 20.4852,
    y2: 20.9852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2489BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0575B3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIcon);
export default __webpack_public_path__ + "static/media/linked_icon.29e6774de4c53ccfcd8ca50e678a751b.svg";
export { ForwardRef as ReactComponent };